import { axiosClient } from "services/axios";

import { Item } from "../../../types";

import { GetProductsParams } from "../types";

export function getProducts({
  page = 1,
  pageSize = 1000,
  group,
}: GetProductsParams = {}): Promise<Item[] | void> {
  return axiosClient
    .get("items", {
      params: {
        page,
        pageSize,
        group,
      },
    })
    .then((res) => res.data as Item[]);
}

export function deleteProduct(itemid: string) {
  return axiosClient.post("items/item-delete", {
    itemid,
  });
}
